export default __webpack_public_path__ + "static/media/HospitalFull.3ca48349.svg";